import { render, staticRenderFns } from "./minMaxItem.vue?vue&type=template&id=b4855d74&"
import script from "./minMaxItem.vue?vue&type=script&lang=js&"
export * from "./minMaxItem.vue?vue&type=script&lang=js&"
import style0 from "./minMaxItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports